import { BaseButton } from "@/components/atom/button/BaseButton";
import { FormTextInput } from "@/components/atom/textInput/form/FormTextInput";
import { EquipmentAutoComplete } from "@/components/organism/autoComplete/equipment/equipment-autoComplete";
import { LocationAutoComplete } from "@/components/organism/autoComplete/location/location-autoComplate";
import { PrinterAutoComplete } from "@/components/organism/autoComplete/print/printer-autoComplete";
import FormTemplate from "@/components/template/form/FormTemplate";
import { COMMON_TEXT } from "@/constants/text";
import { useModal } from "@/context/ModalStackManager";
import { useWorkHandler } from "@/hooks/handler/useWorkHandler";
import { useWorkDataStore } from "@/store/work.store";
import { useForm } from "@mantine/form";

const Work = Object.assign(
  {},
  {
    Template: FormTemplate,
    Button: BaseButton,
    TextInput: FormTextInput,
    Select: PrinterAutoComplete,
    EquipmentAutoComplete: EquipmentAutoComplete,
    LocationAutoComplete: LocationAutoComplete,
  }
);


export const WorkUpdateForm = () => {
  const { closeModal } = useModal();
  const { onSubmit } = useWorkHandler();
  const { workData } = useWorkDataStore((state) => ({
    workData: state.workData,
  }));
  const { work } = workData;

  const form = useForm({
    initialValues: {
      id: work?.id || 1,
      equipmentCode: work?.equipmentCode || '', //설비코드
    },
  });

  const handleSubmit = () => {
    onSubmit({
      DefaultApiWorksWorkIdPutRequest: {
        workId: form.values.id as number,
        worksWorkIdDeleteRequest: {
          equipmentCode: form.values.equipmentCode,
        },
      },
    });
    closeModal({});
  };

  return (
    <Work.Template onSubmit={handleSubmit} onCancel={() => closeModal({})}>
      <Work.EquipmentAutoComplete
        label={COMMON_TEXT.LABEL.EQUIPMENT}
        defaultValue={form.values?.equipmentCode}
        {...form.getInputProps("equipmentCode")}
      />
    </Work.Template>
  );
};
